import { z } from 'zod';

function getPublicApiOrigin() {
  return z
    .string({
      required_error: 'PUBLIC_API_ORIGIN must be set in environment variables',
      invalid_type_error: 'PUBLIC_API_ORIGIN must be a string',
    })
    .parse(process.env.PUBLIC_API_ORIGIN);
}

/**
 * Resolves the API origin for `send()` and any other API request.
 *
 * In the browser this is always the public, Cloudflare-fronted
 * `PUBLIC_API_ORIGIN`. On the SSR Node server we prefer the internal API host
 * (`API_HOST` / `API_SCHEME`) when it is configured, so server-originated
 * requests bypass the public Cloudflare edge and its global rate limit — SSR
 * traffic egresses from a handful of shared NAT IPs with a non-browser
 * user-agent and otherwise trips that rule.
 *
 * `API_HOST` / `API_SCHEME` are runtime ECS env vars (e.g.
 * `api.internal.hungryroot.com:443` + `https`). Unlike `PUBLIC_API_ORIGIN` they
 * are not inlined by the build `define` step, so they stay genuine runtime
 * reads on the server and are absent (→ public fallback) in the browser and in
 * local dev. `process` is guarded so the reference is safe in the browser
 * bundle even though that branch never executes there.
 */
export function getApiOrigin() {
  if (typeof window === 'undefined' && typeof process !== 'undefined') {
    const apiHost = process.env.API_HOST;
    if (apiHost) {
      const scheme = process.env.API_SCHEME ?? 'https';
      return `${scheme}://${apiHost}`;
    }
  }

  return getPublicApiOrigin();
}
